// extracted by mini-css-extract-plugin
export var cursor = "style-module--cursor--974ba";